import type { EntityDialogPresentation } from './entity.dialog.contracts';

/**
 * A sized dialog with no fixed height sizes to its body. The inspector renderer paints nothing
 * while the surface resolves, so the panel would otherwise flash as a 48px header and grow down
 * into the form. Hold the first paint until a body that can hug is in the tree.
 */
export function hugDialogHoldsReveal(presentation: EntityDialogPresentation | undefined | null): boolean {

  if (!presentation) return false;
  const height = presentation.height;
  return height == null || height === 'auto';
}

/**
 * Anything the hugging panel can size against: a mounted surface host, an explicit empty/error
 * state, or a custom operation component. `wb-surface` itself does not count — it exists before
 * the host is projected and is still zero height.
 */
export function hugDialogBodyPresent(panel: ParentNode): boolean {

  if (panel.querySelector('wb-surface > *, .entity-inspector-state, .entity-dialog-custom-state')) return true;

  for (const child of panel.children) {
    if (!(child instanceof HTMLElement)) continue;
    if (child.classList.contains('entity-dialog-header')) continue;
    if (child.tagName === 'ENTITY-INSPECTOR-RENDERER') continue;
    return true;
  }

  return false;
}
